import { createAction } from '@reduxjs/toolkit'
import {
  type AdminCompanyWithoutUsers,
  type AssignUserToCompanySuccessPayload,
  type CompanyIntegration,
  type CreateCompanyActionPayload,
  type DeleteCompanyPayload,
  type DownloadFileForAdminPayload,
  type DownloadFileWithinSpecificDatesForAdminPayload,
  type DownloadTransferFileForAdminPayload,
  type FetchCompaniesSuccessPayload,
  type FetchCompanyUsersSuccessPayload,
  type OpenEditCompanyDialogPayload,
  type SearchCompaniesSuccessPayload,
  type UnassignedUsersPayload,
  type UpdateCompanyActionPayload,
  type UpdateIntegrationPayload,
  type UserChangeActionPayload
} from './admin-companies-types'

/* Action Creators */

export const FetchCompaniesAction = createAction('companies/fetch/request')
export const FetchCompaniesSuccessAction = createAction<FetchCompaniesSuccessPayload>('companies/fetch/success')
export const FetchCompaniesFailAction = createAction('companies/fetch/failure')

export const FetchUnassignedUsersAction =
    createAction('companies/users/fetchUnassignedUsers')
export const FetchUnassignedUsersSuccessAction =
    createAction<UnassignedUsersPayload>('companies/users/fetchUnassignedUsersSuccess')
export const FetchUnassignedUsersFailedAction =
    createAction('companies/users/fetchUnassignedUsersFailure')

export const FetchCompanyUsersAction = createAction<{ companyId: string }>('companies/users/fetchCompanyUsersRequest')
export const FetchCompanyUsersSuccessAction = createAction<FetchCompanyUsersSuccessPayload>('companies/users/fetchCompanyUsersSuccess')
export const FetchCompanyUsersFailedAction = createAction('companies/users/fetchCompanyUsersFailure')

export const CreateCompanyAction = createAction<CreateCompanyActionPayload>('companies/create/request')
export const CreateCompanySuccessAction = createAction<AdminCompanyWithoutUsers>('companies/create/success')
export const CreateCompanyFailedAction = createAction('companies/create/failure')

export const DeleteCompanyAction = createAction<DeleteCompanyPayload>('companies/delete/request')
export const DeleteCompanySuccessAction = createAction<DeleteCompanyPayload>('companies/delete/success')
export const DeleteCompanyFailedAction = createAction('companies/delete/failure')

export const UpdateCompanyAction = createAction<UpdateCompanyActionPayload>('companies/update/request')
export const UpdateCompanySuccessAction = createAction<AdminCompanyWithoutUsers>('companies/update/success')
export const UpdateCompanyFailedAction = createAction('companies/update/failure')

export const AssignUserToCompanyAction =
    createAction<UserChangeActionPayload>('companies/users/assignUserRequest')
export const AssignUserToCompanySuccessAction =
    createAction<AssignUserToCompanySuccessPayload>('companies/users/assignUserSuccess')
export const AssignUserToCompanyFailedAction = createAction('companies/users/assignUserFailure')

export const DeleteCompanyUserAction =
    createAction<UserChangeActionPayload>('companies/users/deleteRequest')
export const DeleteCompanyUserSuccessAction =
    createAction<UserChangeActionPayload>('companies/users/deleteSuccess')
export const DeleteCompanyUserFailedAction =
    createAction('companies/users/deleteFailure')

export const FetchCompanyIntegrationAction = createAction<{ companyId: string }>('companies/integrations/fetchRequest')
export const FetchCompanyIntegrationSuccessAction =
    createAction<CompanyIntegration>('companies/integrations/fetchSuccess')
export const FetchCompanyIntegrationFailedAction =
    createAction('companies/integrations/fetchFailure')

export const UpdateCompanyIntegrationAction =
    createAction<UpdateIntegrationPayload>('companies/integrations/updateRequest')
export const UpdateCompanyIntegrationSuccessAction =
    createAction<CompanyIntegration>('companies/integrations/updateSuccess')
export const UpdateCompanyIntegrationFailedAction =
    createAction('companies/integrations/updateFailure')

export const DeleteCompanyIntegrationAction = createAction<{
  companyId: string
}>('companies/integrations/deleteRequest')

export const DeleteCompanyIntegrationSuccessAction = createAction<{
  companyId: string
}>('companies/integrations/deleteSuccess')
export const DeleteCompanyIntegrationFailedAction = createAction('companies/integrations/deleteFailure')

export const SearchCompaniesAction = createAction<SearchCompaniesSuccessPayload>('companies/search/termChanged')
export const OpenEditCompanyDialogAction = createAction<OpenEditCompanyDialogPayload>('companies/edit/openDialog')

export const SetCompanyEditModeAction = createAction<{ editMode: boolean }>('companies/edit/setEditMode')

export const DownloadFileForAdminAction =
    createAction<DownloadFileForAdminPayload>('companies/downloadFileAsAdmin/withStartDate')

export const DownloadFileWithinSpecificDatesForAdminAction =
    createAction<DownloadFileWithinSpecificDatesForAdminPayload>('companies/downloadFileAsAdmin/withSpecificDates')

export const DownloadTransferFileForAdminAction =
    createAction<DownloadTransferFileForAdminPayload>('companies/downloadFileAsAdmin/transferFile')
